import { render, staticRenderFns } from "./TratamentoCartorioChecklist.vue?vue&type=template&id=c060edfe"
import script from "./TratamentoCartorioChecklist.vue?vue&type=script&lang=js"
export * from "./TratamentoCartorioChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports